import { render, staticRenderFns } from "./CamaraVOD.vue?vue&type=template&id=1406ac4d&"
import script from "./CamaraVOD.vue?vue&type=script&lang=ts&"
export * from "./CamaraVOD.vue?vue&type=script&lang=ts&"
import style0 from "./CamaraVOD.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1406ac4d', component.options)
    } else {
      api.reload('1406ac4d', component.options)
    }
    module.hot.accept("./CamaraVOD.vue?vue&type=template&id=1406ac4d&", function () {
      api.rerender('1406ac4d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Camaras/VOD/CamaraVOD.vue"
export default component.exports